'use strict';

const allCalendarEvents = state => {
  return state.calendarEvents.slice();
};

export default {
  allCalendarEvents
};
